// extracted by mini-css-extract-plugin
export default {"landing-subtitle":"I3PBO7","landingSubtitle":"I3PBO7"};